import { Link } from "react-router-dom";
import { Avatar } from "./Posts";

// Foto + nome del paziente cliccabili -> apre la CHAT canonica con quel paziente
// (stessa logica del pulsante "Chat" della pagina Follower: /chat/:id, nessuna conversazione duplicata).
// stopPropagation: non attiva click di card contenitrici (es. card ordine). Senza id -> statico.
export function PatientLink({ id, name, avatarUrl, cls = "w-9 h-9 text-sm", nameCls = "text-sm", testid = "patient-link" }) {
  if (!id) return (
    <span className="flex items-center gap-2 min-w-0">
      <Avatar url={avatarUrl} label={name} cls={cls} />
      <span className={`${nameCls} text-slate-600 truncate`}>{name}</span>
    </span>);
  return (
    <Link to={`/chat/${id}`} onClick={(e) => e.stopPropagation()}
      className="flex items-center gap-2 rounded-lg -m-1 p-1 hover:bg-slate-50 focus:outline-none focus:ring-2 focus:ring-blue-500 w-fit min-w-0"
      data-testid={testid}>
      <Avatar url={avatarUrl} label={name} cls={cls} />
      <span className={`${nameCls} text-blue-600 hover:underline truncate`}>{name}</span>
    </Link>);
}
